import React, { useContext } from 'react';
import { Button } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CurrentApplicationContext } from '../../ApplicationOverview';
import { apiPost } from 'helpers/ApiHelper';
import { getTranslatedString } from 'helpers/i18n';
import { leaseManagementWip } from './WipModal';

const createLeaseText = getTranslatedString(
  'landlordPortal.applicationManagement.applicationOverview.CreateLease'
);

const CreateLeaseButton = () => {
  const application = useContext(CurrentApplicationContext);
  const queryClient = useQueryClient();

  const createLeaseMutation = useMutation({
    mutationFn: (application) =>
      apiPost(`/landlords/application_management/applications/${application?.id}/create_lease`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['applications'] }),
  });

  return (
    <Button
      loading={createLeaseMutation.isLoading}
      type="primary"
      onClick={() => leaseManagementWip(() => createLeaseMutation.mutate(application))}
    >
      {createLeaseText}
    </Button>
  );
};

export default CreateLeaseButton;
